import { HttpClient, Response, tryRequest } from 'utils/axios'

export const makeGetProfile =
  (client: HttpClient) => (): Promise<Response<UserSession>> =>
    tryRequest(client.get('auth/identity'))
